// A subtle "now playing" credit toast (top-right, clear of the panel and minimap). Shows each music
// track's title + format for a few seconds when it begins, linking to its source. Mirrors
// wiiplaytanks' HUD music credit.

import type { MusicTrack } from "../engine/music";

const HOLD_MS = 6500;

export class NowPlaying {
  private el: HTMLAnchorElement;
  private timer = 0;

  constructor(container: HTMLElement) {
    const a = document.createElement("a");
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    Object.assign(a.style, {
      position: "fixed",
      right: "12px",
      top: "12px",
      maxWidth: "320px",
      padding: "8px 12px",
      background: "rgba(12,16,20,0.86)",
      border: "1px solid #2a3038",
      borderRadius: "8px",
      color: "#dfe3ea",
      font: "12px/1.45 'Courier New', monospace",
      textDecoration: "none",
      opacity: "0",
      transition: "opacity 0.5s ease",
      pointerEvents: "none",
      zIndex: "20",
    } as CSSStyleDeclaration);
    container.appendChild(a);
    this.el = a;
  }

  show(t: MusicTrack): void {
    const fmt = t.formatLong || t.format;
    this.el.href = t.url || "#";
    this.el.innerHTML =
      `<span style="color:#9fe1cb">&#9835; now playing</span><br>` +
      `<b>${esc(t.title)}</b>` +
      (fmt ? ` <span style="color:#8b93a0">&middot; ${esc(fmt)}</span>` : "");
    this.el.style.opacity = "1";
    this.el.style.pointerEvents = "auto";
    if (this.timer) clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      this.el.style.opacity = "0";
      this.el.style.pointerEvents = "none";
    }, HOLD_MS);
  }
}

function esc(s: string): string {
  return s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] as string);
}
